import React from 'react';
import { MetricsElement } from "react-metrics";

import Checkbox from '../../ui/components/checkbox';

const stopProp = event => { event.stopPropagation(); }

export default class FilterGroup extends React.Component {

    static defaultProps = {
        lockFilterGroups: false,
        orientation: 'vertical',
        collapseFilters: false,
    }

    constructor(props) {
        super(props);
        this.state = { expand: props.collapseFilters  ? false : props.orientation === 'vertical'};
        this.expandMenu = this.expandMenu.bind(this);
        this.updateFacet = this.updateFacet.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
      const {lockFilterGroups, index, activeIndex} = nextProps;
      const isDefined = typeof activeIndex === "number";

      if ( isDefined ) {
        return {expand: ( isDefined ? index === activeIndex : !prevState.expand ) || lockFilterGroups };
      } else {
        return null;
      }
    }

    expandMenu() {
        const { lockFilterGroups, expandMenu, index } = this.props;
        if(expandMenu) {
          expandMenu(index);
        }
        else {
          this.setState({expand: lockFilterGroups || !this.state.expand})
        }
    }

    updateFacet = (selectedValues, newValue) => {
        return () => {
            if(this.props.customFacetUpdate){
                return this.props.customFacetUpdate(this.props.facet.key, newValue)
            }
            let index = selectedValues.findIndex(selectedId => selectedId === newValue);
            if(index === -1) {
                selectedValues.push(newValue);
            } else {
                selectedValues.splice(index,1);
            }
            
            this.props.updateFacets(this.props.facet.key, selectedValues);
        }
    }

    renderFacetValues(facetName, facetValues) {
        let {isV2} = this.props;
        let numGroups = 0;
        let initialIndices = this.props.facet.initialIndices;
        let selectedValues = [];
        let {selectedFacets} = this.props;
        let {key: facetKey}  = this.props.facet || {};
        if(initialIndices.length > 1) {
            return [initialIndices.map((index) => {
                let value = facetValues[index];
                let isSelected = selectedFacets ? selectedFacets[facetKey] && selectedFacets[facetKey][value._id] : value.selected; 
                if (isSelected) selectedValues.push(value._id);
                
                return (
                    <MetricsElement
                         element="div"
                         className={`facet-value-detail${value.count == 0 ? ' disabled' : ''}`}
                         data-metrics-event-name="searchFilter"
                         data-metrics-event="e_searchFilter"
                         data-metrics-filter-checked={!value.selected}
                         data-metrics-filter-categories={facetName}
                         data-metrics-filter-value={value.displayName}
                         onClick={value.count > 0 ? this.updateFacet(selectedValues, value._id) : null}
                    >
                        { 
                            isV2
                            ? <Checkbox onClick={stopProp} checked={!!isSelected} readOnly={value.count === 0} counter={value.count} align="left">
                                {value.displayName}
                              </Checkbox>
                            : <>
                                <span className={`chkbox${isSelected ? ' checked' : ''}`}></span>
                                <span className='facet-value-name'>{value.displayName}</span>
                                <span className='facet-value-count'>{ isV2 ? value.count : `(${value.count})` }</span>
                              </>
                        }
                    </MetricsElement>
                )
            }),selectedValues.length];
        } else {
            return [];
        }
    }

    closeMenu = () => {
      const {expandMenu} = this.props;
      if(expandMenu) {
        //close menu if mouse leaves dropdown
        expandMenu(-1);
      }
    }


    render() {
        let { lockFilterGroups, facet, orientation, forceExpand=false} = this.props;

        let hidden = false;
        let numOfSelected;
        let values;
        let isHorizontal = orientation === 'horizontal';

        if(!facet.initialIndices.length) {
            hidden = true;
        } else {
            [values, numOfSelected] = this.renderFacetValues(facet.displayName, facet.facetValues);
        }
        if(!values) {
            hidden = true;
        }

        const displayName = numOfSelected > 0 ? facet.displayName + "  (" + numOfSelected  + ")" : facet.displayName;

        return (
            <div className={`filter-group${(lockFilterGroups || this.state.expand || forceExpand) ? ' expanded' : ''}${hidden ? ' hidden' : ''}${forceExpand ? ' no-bottom-border' : ''}${facet.displayName !== displayName ? ' multiple-items-selected' : ''}`}>
                <h3 className='filter-header' onClick={this.expandMenu}>
                    {displayName}
                    { !forceExpand && (!lockFilterGroups || isHorizontal) ? <span className="arrow"></span> : null}
                </h3>
                <div onMouseLeave={!forceExpand && (!lockFilterGroups || isHorizontal) ? this.closeMenu : null} >
                  <ul className={`facet-values${forceExpand ? ' border' : ''}`}>
                    {values && values.map((value, i) => {
                        if (value) {
                            return (
                                <li className='facet-value' key={i}>{value}</li>
                            );
                        } else {
                            return null;
                        }
                    })}
                  </ul>
                </div>
            </div>
        )
    }
}
